import { h } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize, getQdsIconLibrary } from '@pes-ui/utils';
export class MarketingBanner {
  constructor() {
    this.title = undefined;
    this.description = undefined;
    this.cta = undefined;
    this.iconName = undefined;
    this.onCTAClick = undefined;
  }
  render() {
    return (h("div", { class: "marketing-banner" }, h("div", { class: "marketing-banner-content" }, h("div", { class: "icon-container" }, h("qds-icon", { class: "banner-icon", name: this.iconName, library: getQdsIconLibrary(this.iconName) })), h("div", { class: "marketing-banner-text-container" }, h("h4", { class: "marketing-banner-title", innerHTML: this.title }), h("p", { class: "marketing-banner-description", innerHTML: this.description }))), h("qds-button", { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED, class: "marketing-products-tab__button", onClick: this.onCTAClick.bind(this, this.cta.url), href: this.cta.url, text: this.cta.label })));
  }
  static get is() { return "pes-marketing-banner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["marketing-banner.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["marketing-banner.css"]
    };
  }
  static get properties() {
    return {
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "cta": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "BannerCTA",
          "resolved": "BannerCTA",
          "references": {
            "BannerCTA": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "iconName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon-name",
        "reflect": false
      },
      "onCTAClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(url: string, event: Event) => Promise<void> | void",
          "resolved": "(url: string, event: Event) => void | Promise<void>",
          "references": {
            "Event": {
              "location": "global"
            },
            "Promise": {
              "location": "global"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
